<template>
  <el-dialog
    title="修改银行信息"
    :visible.sync="dialogFormEditCompanyInfo"
    @close="close"
    :modal-append-to-body="false"
    :close-on-click-modal="false"
  >
    <el-form :model="form" :rules="rules" label-width="100" ref="form">
      <el-form-item label="银行开户名：" prop="bankCompanyName">
        <el-input v-model="form.bankCompanyName"></el-input>
      </el-form-item>

      <el-form-item label="银行账号：" prop="bankCardNo">
        <el-input v-model="form.bankCardNo"></el-input>
      </el-form-item>

      <el-form-item label="开户行支行名称：" prop="bankBranchName">
        <el-input v-model="form.bankBranchName"></el-input>
      </el-form-item>

      <el-form-item label="开户行联行号：" prop="bankBranchNo">
        <el-input v-model="form.bankBranchNo"></el-input>
      </el-form-item>
    </el-form>

    <div slot="footer" class="dialog-footer">
      <el-button @click="close">取 消</el-button>

      <el-button type="primary" @click="submit">确 定</el-button>
    </div>
  </el-dialog>
</template>

<script>
import { modifySecondInfo } from '@/api/distributor-api'
import { SERVICE_PROVIDER_CREATE_RULE } from '@/views/service/rules'
export default {
  props: {
    infoData: {
      require: true,
    },
  },
  components: {},
  mixins: [],
  data() {
    return {
      dialogFormEditCompanyInfo: false,
      distributorId: this.$route.params.id,
      form: {
        bankCompanyName: '',
        bankCardNo: '',
        bankBranchName: '',
        bankBranchNo: '',
      },
      rules: SERVICE_PROVIDER_CREATE_RULE(this),
    }
  },
  watch: {
    infoData(val) {
      this.form = Object.assign({}, val)
    },
  },
  computed: {},
  mounted() {},
  created() {},
  filters: {},
  methods: {
    showDialog() {
      this.dialogFormEditCompanyInfo = true
      this.form = Object.assign({}, this.infoData)
    },
    close() {
      this.$refs.form.resetFields()
      this.dialogFormEditCompanyInfo = false
    },
    submit() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          this.updateFirstClientInfo()
        } else {
          return false
        }
      })
    },
    async updateFirstClientInfo() {
      // let {
      //   bankCompanyName,
      //   bankCardNo,
      //   bankBranchName,
      //   bankBranchNo
      // } = this.form
      let submitForm = Object.assign({}, this.form)
      let { distributorId } = this
      submitForm.distributorId = distributorId
      await modifySecondInfo(submitForm)
      this.outMsg('success', '提交成功')
      this.close()
      this.$emit('submitSuccess')
    },
  },
}
</script>
